import { toast } from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import { loginUserFailure } from '../actions/login.action';
import {
    getAllClientsSuccess,
    createClientSuccess,
    editClientSuccess,
    deleteClientSuccess,
    getClientByIdSuccess
} from '../actions/client.action';
import {
    getAllClientsApi,
    createClientApi,
    editClientApi,
    deleteClientApi,
    getClientByIdApi
} from '../api';
import {
    GET_ALL_CLIENTS,
    CREATE_CLIENT,
    EDIT_CLIENT,
    DELETE_CLIENT,
    GET_CLIENT_BY_ID
} from '../storeTypes';

function* getAllClientsSaga(action) {
    try {
        const response = yield call(getAllClientsApi, action.payload);
        if (response.data.data) {
            yield put(getAllClientsSuccess(response.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else {
            yield put(loginUserFailure(error));
        }
    }
}

function* createClientSaga(action) {
    try {
        const response = yield call(createClientApi, action.payload);
        if (response.data.data) {
            yield put(createClientSuccess(response.data.data));
            toast.success("Client Created Successfully!");
            if (action.callback) action.callback(response);
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        } else {
            yield put(loginUserFailure(error));
        }
    }
}

function* editClientSaga(action) {
    try {
        const response = yield call(editClientApi, action.payload);
        if (response.data.data) {
            yield put(editClientSuccess(response.data.data));
            toast.success("Client Edited Successfully!");
            if (action.callback) action.callback(response);
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        } else {
            yield put(loginUserFailure(error));
        }
    }
}

function* deleteClientSaga(action) {
    try {
        const response = yield call(deleteClientApi, action.payload);
        if (response.data.status === true || response.status === 200) {
            yield put(deleteClientSuccess(action.payload));
            toast.success("Client Deleted Successfully!");
            if (action.callback) action.callback(response);
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else {
            yield put(loginUserFailure(error));
        }
    }
}

function* getClientByIdSaga(action) {
    try {
        const response = yield call(getClientByIdApi, action.payload);
        if (response.data.data) {
            yield put(getClientByIdSuccess(response.data.data));
        }
    } catch (error) {
        if (error?.response?.status === 403) {
            console.error('Token not provided or expired');
        } else {
            yield put(loginUserFailure(error));
        }
    }
}

export function* ClientSaga() {
    yield takeLatest(GET_ALL_CLIENTS, getAllClientsSaga);
    yield takeLatest(CREATE_CLIENT, createClientSaga);
    yield takeLatest(EDIT_CLIENT, editClientSaga);
    yield takeLatest(DELETE_CLIENT, deleteClientSaga);
    yield takeLatest(GET_CLIENT_BY_ID, getClientByIdSaga);
}
